const API_BASE = '';

function toParams(obj) {
    return Object
        .keys(obj)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
        .join('&');
}

function get(endpoint, data, onSuccess, onErr) {
  let url = `${API_BASE}${endpoint}?${toParams(data)}`;
  fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    method: 'GET',
  })
    .then(res => res.json())
    .then((data) => onSuccess(data))
    .catch(err => { console.log(err) });
}

function post(endpoint, data, onSuccess, onErr) {
  let url = `${API_BASE}${endpoint}`;
  fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then((data) => onSuccess(data))
    .catch(err => { throw err });
}

function del(endpoint, data, onSuccess, onErr) {
  let url = `${API_BASE}${endpoint}`;
  fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    method: 'DELETE',
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then((data) => onSuccess(data))
    .catch(err => { throw err });
}

function uploadImage(endpoint, file, crop, onSuccess, onErr) {
  let data = new FormData()
  data.append('image', file);

  // all in %
  data.append('crop_x', crop.x);
  data.append('crop_y', crop.y);
  data.append('crop_w', crop.width);
  data.append('crop_h', crop.height);

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: data
  })
  .then((resp) => {
    if (!resp.ok) {
      throw new Error(resp.statusText);
    }
    return resp.json()
  })
  .then((json) => {
    onSuccess(json);
  })
  .catch((error) => {
    onErr(error);
  });
}


export default {
  get: get,
  post: post,
  delete: del,
  uploadImage: uploadImage
};



// WEBPACK FOOTER //
// ./res/front/static/js/api.js